module.exports = __webpack_public_path__ + "static/media/life-leader-board-banner-desktop.90775f0c.jpg";